import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
  selector: "n-modal-backdrop",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./n-modal-backdrop.css"],
  template: ``
})
export class NModalBackdropComponent {

}
